/* unplugin-vue-components disabled */import { ElDialog as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/dialog/style/css';
import { ElButton as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElForm as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-05a15f40"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "marginB20"
};
const _hoisted_2 = {
  class: "desc-container"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "角色ID：", -1));
const _hoisted_4 = {
  class: "desc-container marginT20"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "原GS昵称：", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "marginL20"
}, "原GSID：", -1));
const _hoisted_7 = {
  class: "dialog-footer"
};
import SelectGS from '../modules/selectGS.vue';
import { apiEditBind } from '@/api/gsManage';
export default /*#__PURE__*/_defineComponent({
  __name: 'toggleBindModal',
  emits: ['ok'],
  setup(__props, {
    expose,
    emit: emits
  }) {
    const dialogVisible = ref(false);
    const formDataRef = ref();
    const infoData = ref();
    const formData = ref({
      gs_chairman_id: undefined
    });
    const handleClose = elForm => {
      dialogVisible.value = false;
      if (!elForm) return;
      elForm.resetFields();
    };
    const handleOk = elForm => {
      if (!elForm) return;
      elForm.validate(async valid => {
        var _infoData$value;
        if (!valid) return;
        const res = await apiEditBind({
          id: (_infoData$value = infoData.value) === null || _infoData$value === void 0 ? void 0 : _infoData$value.id,
          gs_chairman_id: formData.value.gs_chairman_id
        });
        if (res.code === 0) {
          emits('ok');
          handleClose(formDataRef.value);
        }
      });
    };
    const show = payload => {
      dialogVisible.value = true;
      if (payload.data) {
        infoData.value = payload.data;
      }
      console.log('1', infoData.value);
    };
    expose({
      show
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = __unplugin_components_0;
      const _component_el_form = __unplugin_components_1;
      const _component_el_button = __unplugin_components_2;
      const _component_el_dialog = __unplugin_components_3;
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(dialogVisible),
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(dialogVisible) ? dialogVisible.value = $event : null),
        title: "玩家换绑",
        width: "600px",
        "before-close": () => handleClose(_unref(formDataRef))
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_7, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = () => handleClose(_unref(formDataRef)))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = () => handleOk(_unref(formDataRef)))
        }, {
          default: _withCtx(() => [_createTextVNode(" 确定 ")]),
          _: 1
        })])]),
        default: _withCtx(() => {
          var _unref2, _unref3, _unref4;
          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", null, _toDisplayString((_unref2 = _unref(infoData)) === null || _unref2 === void 0 ? void 0 : _unref2.role_id), 1)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, _toDisplayString((_unref3 = _unref(infoData)) === null || _unref3 === void 0 ? void 0 : _unref3.name), 1), _hoisted_6, _createElementVNode("span", null, _toDisplayString((_unref4 = _unref(infoData)) === null || _unref4 === void 0 ? void 0 : _unref4.gs_chairman_id), 1)])]), _createVNode(_component_el_form, {
            ref_key: "formDataRef",
            ref: formDataRef,
            model: _unref(formData),
            "status-icon": ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              rules: {
                required: true,
                message: '请选择新GS',
                trigger: 'change'
              },
              label: "选择新GS",
              prop: "gs_chairman_id"
            }, {
              default: _withCtx(() => [_createVNode(SelectGS, {
                modelValue: _unref(formData).gs_chairman_id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).gs_chairman_id = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["model"])];
        }),
        _: 1
      }, 8, ["modelValue", "before-close"]);
    };
  }
});